import { Component, Prop, Vue } from "vue-property-decorator";

// External components
import Multiselect from "../multiselect/multiselect";

@Component({ components: { Multiselect } })
export default class MultiselectInput extends Vue {
  @Prop({ default: () => [] }) multiselectValues;
  @Prop({ default: "name" }) multiselectDisplayProperty;
  @Prop({ default: null }) selectedMultiselectValue;
  @Prop({ default: "text" }) inputType;
  @Prop({ default: null }) inputValue;
  @Prop({ default: false }) isError;
}
